import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {
    const [name, setname] = useState("") 
    const [lname, setlname] = useState("") 
    const [email, setemail] = useState("") 
    const [subject, setsubject] = useState("") 
    const [Message, setMessage] = useState("") 
    useEffect(() =>{
        window.scrollTo(0, 0)
    },[])

    const Submitdata = (e)=>{
        e.preventDefault()

        fetch("https://paint-saudi-rayidh-main-back.vercel.app/touchIn",{
            method: 'POST' , 
            headers :  {
              "Content-Type" : "application/json" , 
            } , 
            body : JSON.stringify({
              name  ,
              lname  ,
              email  ,
              subject  ,
              Message  ,
            })
          })
          .then((res)=>res.json())
          .then((res2)  =>{
              console.log(res2)
              if (res2){
                swal("SucessFully Send "  )
                setname ("") 
                setlname("") 
                    setemail("") 
                    setsubject("") 
                    setMessage("") 
                // localStorage.setItem("User" , JSON.stringify("Yes") )
                    // props.history.push("/login")
              }
              else if (res2.Error){
                swal(res2.Error )
              }
              else{
                swal("Plz Try Again !"  )
              }
            // console.log(res2)
          })
          .catch((err)=>console.log(err))
        
    }



        return (
            <> 

            <div>
  <main className="main" style={{ direction: "rtl", textAlign: "right" }}>
    <nav aria-label="breadcrumb" className="breadcrumb-nav border-0 mb-0">
      <div className="container">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">الرئيسية</a>
          </li>
          <li
            className="breadcrumb-item active"
            aria-current="page"
            style={{ fontWeight: "800", color: "#008071" }}
          >
            اتصل بنا
          </li>
        </ol>
      </div>
    </nav>

    <div className="page-content pb-0">
      <div className="container">
        {/* === Riyadh Location Map === */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.559233337528!2d46.786300475101945!3d24.763519847117907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03fbeda22da9%3A0x9c201b3c7de1490!2z2LTYp9ixINin2YTYqti52YQg2YHYqNin2YTYjCDZiNio2K3YtNs!5e0!3m2!1sar!2ssa!4v1733648678755"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>

        <div className="row">
          {/* === Right Column === */}
          <div className="col-lg-6 mb-2 mb-lg-0">
            <h2 className="title mb-1" style={{textAlign:"right"}}>معلومات التواصل</h2>
            <p className="mb-3">
              مرحباً بكم في شركة ألوان القوس للدهانات – أفضل متجر دهانات في
              الرياض.
            </p>

            <div className="row">
              <div className="col-sm-7">
                <div className="contact-info">
                  <h3>المتجر</h3>
                  <ul className="contact-list">
                    <li>
                      <i className="icon-map-marker" />
                      6419 أبي عبيدة عامر بن الجراح، حي الفيحاء، الرياض 14254
                    </li>
                    <li>
                      <i className="icon-phone" />
                      <a href="tel:0583812793">058 381 2793</a>
                    </li>
                    <li>
                      <i className="icon-envelope" />
                      <a>Salimkhan48912@gmail.com</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-sm-5">
                <div className="contact-info">
                  <h3>الدوام</h3>
                  <ul className="contact-list">
                    <li>
                      <i className="icon-clock-o" />
                      <span className="text-dark">السبت - الخميس</span>
                      <br />
                      5:14 ص – 9:14 م
                    </li>
                    <li>
                      <i className="icon-clock-o" />
                      <span className="text-dark">الجمعة</span>
                      <br />
                      مغلق
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* === Left Column === */}
          <div className="col-lg-6">
            <h2 className="title mb-1" style={{textAlign:"right"}}>هل لديك أي استفسار؟</h2>
            <p className="mb-2">استخدم النموذج أدناه للتواصل معنا</p>

            <form onSubmit={(e) => Submitdata(e)}>
              <div className="row">
                <div className="col-sm-6">
                  <label className="sr-only">الاسم الأول</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="الاسم الأول *"
                    required
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                  />
                </div>

                <div className="col-sm-6">
                  <label className="sr-only">الاسم الأخير</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="الاسم الأخير *"
                    required
                    value={lname}
                    onChange={(e) => setlname(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <label className="sr-only">هاتف</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="رقم الهاتف"
                    value={subject}
                    onChange={(e) => setsubject(e.target.value)}
                  />
                </div>

                <div className="col-sm-6">
                  <label className="sr-only">البريد الإلكتروني</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="البريد الإلكتروني *"
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                  />
                </div>
              </div>

              <label className="sr-only">الرسالة</label>
              <textarea
                className="form-control"
                rows={4}
                placeholder="اكتب رسالتك هنا *"
                required
                value={Message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button type="submit" className="btn btn-outline-primary-2 btn-minwidth-sm">
                <span>إرسال</span>
                <i className="icon-long-arrow-left" />
              </button>
            </form>
          </div>
        </div>

        <hr className="mt-4 mb-5" />
      </div>
    </div>
  </main>
</div>


            </>
           
        )
    
}


export default Contact;